import React from 'react';

const AddToCalendar: React.FC = () => {
  const eventDetails = {
    title: "Daniel’s 2nd Birthday Party! 🚂",
    description: "Join us to celebrate Daniel’s 2nd birthday! Choo choo fun, cake, and lots of playtime!",
    location: "Seattle Children's Museum (Seattle Center), Seattle, WA",
    startDate: "2026-06-13T10:30:00",
    endDate: "2026-06-13T13:00:00",
  };

  const formatGoogleCalendarUrl = () => {
    const baseUrl = 'https://calendar.google.com/calendar/render?action=TEMPLATE';
    const params = new URLSearchParams({
      text: eventDetails.title,
      details: eventDetails.description,
      location: eventDetails.location,
      dates: `${eventDetails.startDate.replace(/[-:]/g, '')}/${eventDetails.endDate.replace(/[-:]/g, '')}`,
    });
    return `${baseUrl}&${params.toString()}`;
  };

  const formatIcsFile = () => {
    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `SUMMARY:${eventDetails.title}`,
      `DTSTART:${eventDetails.startDate.replace(/[-:]/g, '')}`,
      `DTEND:${eventDetails.endDate.replace(/[-:]/g, '')}`,
      `DESCRIPTION:${eventDetails.description}`,
      `LOCATION:${eventDetails.location}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\n');

    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    return URL.createObjectURL(blob);
  };

  return (
    <div className="text-center mt-8 border-t border-gray-200 pt-8">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Save the Date! 📅</h3>
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <a
          href={formatGoogleCalendarUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-sky-700 hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-700"
        >
          Add to Google Calendar
        </a>
        <a
          href={formatIcsFile()}
          download="daniels-2nd-birthday.ics"
          className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-sky-700 hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-700"
        >
          Download for Other Calendars
        </a>
      </div>
    </div>
  );
};

export default AddToCalendar; 